<template>
  <div class="ot-outline">
    <slot></slot>
  </div>
</template>

<style scoped>
.ot-outline {
  background: 
    /* Corners */ url("../assets/images/border-top-left.png")
      no-repeat left top border-box,
    url("../assets/images/border-top-right.png") no-repeat right top border-box,
    url("../assets/images/border-bottom-left.png") no-repeat left bottom
      border-box,
    url("../assets/images/border-bottom-right.png") no-repeat right bottom
      border-box,
    /* Sides */ url("../assets/images/border-top.png") no-repeat top border-box,
    url("../assets/images/border-bottom.png") no-repeat bottom border-box,
    url("../assets/images/border-left.png") no-repeat left border-box,
    url("../assets/images/border-right.png") no-repeat right border-box,
    /* Fill */ linear-gradient(to bottom, #fcf688, #fcf688) padding-box;
  background-size: 
    /* Corners */ 18px 17px, 16px 16px, 20px 18px, 16px 16px,
    /* Sides */ calc(100% - 30px) 15px, calc(100% - 30px) 15px,
    15px calc(100% - 30px), 15px calc(100% - 30px), /* Middle sides */ 15px 15px,
    15px 15px, /* Fill */ 100% 100%;
  border: 5px solid transparent;
  outline: none;
  padding: 10px;
}
</style>
